import React from 'react';
import QuestionCard from './QuestionCard';
import ProgressBar from './ProgressBar';
import NavigationButtons from './NavigationButtons';

const SurveyStep = ({
  stepData,
  currentStep,
  totalSteps,
  responses,
  onToggleResponse,
  onNext,
  onBack,
  onAnalyze,
  loading
}) => {
  if (!stepData) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">Loading questions...</p>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto">
      <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />

      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          {stepData.title}
        </h2>
        <div className="flex items-start space-x-3 bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 mt-3">
          <svg className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-sm text-blue-800">
            <span className="font-semibold">Select everything that interests you</span> — there are no right or wrong answers.{' '}
            <span className="font-semibold">Nothing catching your eye? That's okay!</span> You can skip any or all questions on this page and move on.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {stepData.questions.map((question) => (
          <QuestionCard
            key={question.id}
            question={question}
            isSelected={responses[question.id] || false}
            onToggle={() => onToggleResponse(question.id)}
          />
        ))}
      </div>

      <NavigationButtons
        currentStep={currentStep}
        totalSteps={totalSteps}
        onBack={onBack}
        onNext={onNext}
        onAnalyze={onAnalyze}
        loading={loading}
      />
    </div>
  );
};

export default SurveyStep;
